import debounce from 'lodash/debounce'
import { proxyNewUser } from '../../../../shared/proxies/newUserProxy'
import { executeUserDataExportsSearch } from './executeUserDataExportsSearch'

const handleFetch = async (): Promise<void> => {
  await executeUserDataExportsSearch({ appendRecords: false, displayLoader: true })
  setTimeout(() => {
    proxyNewUser.completed = false
  }, 3000)
}
export const debouncedHandleFetch = debounce(handleFetch, 100)
